import { useQuery } from 'src/shared/lib/useQuery';
import { useAuth } from 'src/features/auth/contexts/AuthContext';

export function usePrimaryUser() {
  const { apiFetch } = useAuth();

  const queryKey = ['primary-user'];

  return useQuery({
    queryKey,
    queryFn: getData,
  });

  async function getData() {
    const response = await apiFetch<{ emailVerified: boolean }>('/api/v2/account/primary-user', {
      method: 'GET',
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(`Failed to fetch primary user`);
    }

    return data;
  }
}
